import React, { useRef, useCallback, MouseEvent, useState }  from 'react';
import dropdownCaret from './dropdown-caret.svg';
import dropdownCaretSelected from './dropdown-caret--selected.svg';
import languageIcon from '../language-selector/language-icon.svg';
import languageIconSelected from '../language-selector/language-icon-selected.svg';
import './menu-bar.css';
import { supportedLanguages, useSettings } from "../settings/settings";

export interface LanguageMenuItemProps {
    // handleChange: () => void,
    // onClickLanguage: () => void,
    // onRequestCloseLanguage: () => void,
    // languageMenuOpen?: boolean
}
let timer = null

const LanguageMenuItem = ({
}: LanguageMenuItemProps) => {
    const languageRef = useRef<HTMLInputElement>(null);

    // 鼠标移入移除
    const [language, setLanguage] = useState<boolean>(false);
    // 鼠标移动展示语言下拉框
    const handleMouseEnter = (event: MouseEvent) => {
        clearTimeout(timer);
        setLanguage(true);
    }
    const handleMouseLeaveOuter = (event: MouseEvent) => {
        timer = setTimeout(() => {
            setLanguage(false)
        }, 200);
    }
    // 鼠标移除事件
    const handleMouseLeave = (event: MouseEvent) => {
        setLanguage(false);
    }
    // 点击语言切换
    const [settings, setSettings] = useSettings();
    const handleChooseLanguage = useCallback(
        (languageId: string) => {
          setSettings({
            ...settings,
            languageId,
          });
        },
        [settings, setSettings]
    );
    return (
            <div
                ref={languageRef}
                className={language ? 'menuBarItemSelect' : 'menuBarItem'}
            >
                <div
                    style={{display: 'flex'}}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeaveOuter}
                >
                    <img
                        className="menuIcon"
                        src={language
                                ? languageIconSelected
                                : languageIcon
                        }
                    />
                    <img
                        className="languageCaret"
                        src={language
                                ? dropdownCaretSelected
                                : dropdownCaret
                        }
                    />
                </div>
                {language && 
                    <div 
                        className="languageMenuContainer"
                        onMouseEnter={handleMouseEnter}
                        onMouseLeave={handleMouseLeave}
                    >
                        {supportedLanguages.map((item) => {
                            return (
                                <div
                                    className="languageMenuItem"
                                    key={item.id}
                                    onClick={() => handleChooseLanguage(item.id)}
                                >
                                    <div className="line"></div>
                                    {item.name}
                                </div>
                            );
                        })}
                    </div>
                }
                
            </div>
        );
}

export default LanguageMenuItem;